module.exports = __webpack_public_path__ + "img/LR_logo.936ac829.svg";